import React from 'react';
import { Button, Space } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { SetupTabProps } from '../types.d';
import { TEST_EMAIL_MODAL_CONSTANTS } from '../constants';
import {
  FormSection,
  FormLabel,
  StyledInput,
  StyledTextarea,
  HelpText,
  AlertBox,
  FieldWrapper,
  LabelRow,
} from '../styles';

const SetupTab: React.FC<SetupTabProps> = ({
  testEmail,
  onTestEmailChange,
  testData,
  onTestDataChange,
  jsonError,
  onLoadDefaultData,
  onReset,
}) => {
  return (
    <FormSection>
      <FieldWrapper>
        <FormLabel>{TEST_EMAIL_MODAL_CONSTANTS.FORM_LABELS.TEST_EMAIL_ADDRESS}</FormLabel>
        <StyledInput
          type="email"
          value={testEmail}
          onChange={(e) => onTestEmailChange(e.target.value)}
          placeholder={TEST_EMAIL_MODAL_CONSTANTS.FORM_PLACEHOLDER.EMAIL}
          size="large"
        />
      </FieldWrapper>

      <FieldWrapper>
        <LabelRow>
          <FormLabel style={{ marginBottom: 0 }}>
            {TEST_EMAIL_MODAL_CONSTANTS.FORM_LABELS.TEST_DATA}
          </FormLabel>
          <Space size="small">
            <Button
              type="default"
              size="small"
              icon={<ReloadOutlined />}
              onClick={onLoadDefaultData}
            >
              {TEST_EMAIL_MODAL_CONSTANTS.BUTTONS.LOAD_DEFAULT}
            </Button>
            <Button type="text" size="small" onClick={onReset}>
              {TEST_EMAIL_MODAL_CONSTANTS.BUTTONS.RESET}
            </Button>
          </Space>
        </LabelRow>
        <StyledTextarea
          value={testData}
          onChange={(e) => onTestDataChange(e.target.value)}
          placeholder={TEST_EMAIL_MODAL_CONSTANTS.FORM_PLACEHOLDER.TEST_DATA}
          rows={12}
        />
        {jsonError && <AlertBox type="error">{jsonError}</AlertBox>}
        <HelpText>{TEST_EMAIL_MODAL_CONSTANTS.HELP_TEXTS.TEST_DATA_HELP}</HelpText>
      </FieldWrapper>
    </FormSection>
  );
};

export default SetupTab;
